import { render, staticRenderFns } from "./ShortQuestion.vue?vue&type=template&id=5b77cb44"
import script from "./ShortQuestion.vue?vue&type=script&lang=js"
export * from "./ShortQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports